<template>
  <div class="form-render">
    <draggable
      class="widget-form-list"
      :list="option.columns"
      :group="{ name: 'form' }"
      ghost-class="ghost"
      :animation="300"
      @add="handleWidgetAdd"
      @end="handleWidgetChange"
    >
      <div
        v-for="(col, i) in option.columns"
        :key="i"
        class="widget-form-list__item"
        :style="`width:${100/(12/(col.formOption.span || 12))}%`"
        @click="handleSelectField(col.field)"
      >
        <FieldRender
          :column="col"
          :is-current="col.field===currentField"
          @delete="handleFieldDelete(i)"
          @clone="handleFieldClone(i)"
          @change="change"
        />
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { deepClone } from '@/util/util'
import { Log } from '@icon-park/vue'
import FieldRender from './fieldRender.vue'

export default {
  components: {
    FieldRender,
    Draggable,
  },
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columns: [],
      currentField: -1,
    }
  },
  // watch: {
  //   option: {
  //     handler(e) {
  //       const findCol = this.option.columns.find(o => o.field === this.currentField) || {}
  //       this.$emit('selectField', findCol)
  //     },
  //     immediate: true,
  //     deep: true,
  //   },
  // },
  methods: {
    componentAdd(e) {
      const temp = deepClone(e)
      const random = `${Date.now()}_${Math.ceil(Math.random() * 99999)}`
      temp.field = random
      this.option.columns.push(temp)
      this.$nextTick(() => {
        this.handleSelectField(random)
      })
    },
    handleSelectField(field) {
      this.currentField = field
      const findCol = this.option.columns.find(o => o.field === field) || {}

      this.$emit('selectField', findCol)
    },
    handleFieldDelete(index) {
      this.$nextTick(() => {
        this.option.columns.splice(index, 1)
      })
    },
    handleFieldClone(index) {
      const cloneData = deepClone(this.option.columns[index])
      const random = `${Date.now()}_${Math.ceil(Math.random() * 99999)}`
      cloneData.field = random
      this.option.columns.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.handleSelectField(random)
      })
    },
    handleWidgetAdd(evt) {
      const { newIndex } = evt
      const cloneData = deepClone(this.option.columns[newIndex])
      const random = `${Date.now()}_${Math.ceil(Math.random() * 99999)}`
      cloneData.field = random
      this.$set(this.option.columns, newIndex, cloneData)
    },
    handleWidgetChange() {

    },
    change(e) {
      this.$emit('change', e)
    },
  },
}

</script>

<style lang='scss' scoped>
.form-render{
  height: 100%;
  .widget-form-list{
    height: 100%;
    overflow: auto;
    &__item{
      display: inline-block;
      vertical-align: top;
      transition: width .3s;
    }
  }
}
</style>
